import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

const icons = {
  PersonAddAlt1Icon,
  AdminPanelSettingsIcon
};

const userCreate = {
  id: 'userCreation',
  // title: 'User Creation',
  type: 'group',
  icon: icons.AdminPanelSettingsIcon,
  children: [
    {
      id: 'createUser',
      title: 'Create User',
      type: 'item',
      url: '/create-gadget-user',
      icon: icons.PersonAddAlt1Icon,
    },
  ]
};

export default userCreate;
